/**
 * TanStack Query hooks for `capi-test-event-mode-for-verification`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	getOne,
	list,
	capiTestEventModeForVerificationQueryKeys,
	type CreateCapiTestEventBody,
	type CreateCapiTestEventResponse,
	type ListCapiTestEventsResponse,
	type CapiTestEventRow,
	type TestModeFilter,
} from "./api";

export function useCapiTestEventList(
	filter: TestModeFilter = "all",
): UseQueryResult<ListCapiTestEventsResponse, Error> {
	return useQuery({
		queryKey: capiTestEventModeForVerificationQueryKeys.list(filter),
		queryFn: () => list(filter),
	});
}

export function useCapiTestEventCreate(): UseMutationResult<
	CreateCapiTestEventResponse,
	Error,
	CreateCapiTestEventBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capiTestEventModeForVerificationQueryKeys.all });
		},
	});
}

export function useCapiTestEventDetail(
	event_id: string,
	enabled = true,
): UseQueryResult<CapiTestEventRow, Error> {
	return useQuery({
		queryKey: capiTestEventModeForVerificationQueryKeys.detail(event_id),
		queryFn: () => getOne(event_id),
		enabled: enabled && event_id.length > 0,
	});
}
